import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import type { NodeCfg } from '../nodes';
import { locationSchema } from '../../location.deployParam';

export const addMaterialNoteCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('addMaterialNote'),
    controlValues: z.object({
        isConcern: z.boolean(),
        location: locationSchema,
    }),
});
export type AddMaterialNoteNodeCfgSchema = z.infer<typeof addMaterialNoteCfgSchema>;

export const addMaterialNoteNodeSocketCfg = {
    controlSockets: {
        outputs: () => ({ next: 'event' }),
        inputs: () => ({ trigger: 'event' }),
    },
    dataSockets: {
        inputs: (_cfg: NodeCfg<'addMaterialNote'>) => {
            const ret: Record<'note' | 'materialId', 'string'> = {
                note: 'string',
                materialId: 'string',
            };
            return ret;
        },
        outputs: (_cfg: NodeCfg<'addMaterialNote'>) => {
            return {};
        },
    },
} satisfies NodeSocketCfg<AddMaterialNoteNodeCfgSchema>;
